export const priceMask = {
  mask: Number,
  scale: 2,
  signed: false,
  min: 0,
  radix: ',',
  thousandsSeparator: ' ',
  mapToRadix: ['.'],
  normalizeZeros: true,
  unmask: 'typed'
}
